import { render } from "./asset.vue?vue&type=template&id=313b7831&scoped=true"
import script from "./asset.vue?vue&type=script&lang=js"
export * from "./asset.vue?vue&type=script&lang=js"

import "./asset.vue?vue&type=style&index=0&id=313b7831&scoped=true&lang=scss"

import exportComponent from "D:\\CTS_SURAJ\\mahatakrar\\taxbpo_admin_ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-313b7831"]])

export default __exports__